import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';

import {
  LOAD_ATTENDANCECONTROL,
  CHANGE_ATTENDANCECONTROL,
} from './constants';

import {
  loadAttendanceError,
  loadAttendanceSuccess,
  changeAttendanceError,
  changeAttendanceSuccess,
} from './actions';


import { notification } from 'antd';

export function* loadAttendanceControl(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    const { id } = action;

    // we get the campaigns linked to the attendanceControl
    const attendanceControlData = yield requestWrapper(
      'GET',
      `attendances/${id}`,
      '',
      currentUser.token,
    );

    if (!attendanceControlData) {
      yield put(loadAttendanceSuccess(false));
    } else {
      yield put(loadAttendanceSuccess(attendanceControlData));
    }
  } catch (error) {
    yield put(loadAttendanceError(error));
  }
}

export function* changeAttendanceControl(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { attendanceData } = action;

    let changedAttendanceControl = false,
      isNew = !attendanceData.hasOwnProperty('_id');

    if (attendanceData._id === undefined) {
      changedAttendanceControl = yield requestWrapper(
        'POST',
        'attendances/new/',
        attendanceData,
        currentUser.token,
      );
     // notification.success({ message: 'Created' });
    } else {
      changedAttendanceControl = yield requestWrapper(
        'PATCH',
        'attendances/',
        attendanceData,
        currentUser.token,
      );
     // notification.success({ message: 'Updated' });
    }

    if (!changedAttendanceControl) {
      yield put(changeAttendanceSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/attendanceControl/`+attendanceControlData._id });
      }
      yield put(changeAttendanceSuccess(changedAttendanceControl));
    }
  } catch (error) {
    yield put(changeAttendanceError(error));
  }
}

export default function* attendanceControlSaga() {
  yield takeLatest(LOAD_ATTENDANCECONTROL, loadAttendanceControl);
  yield takeLatest(CHANGE_ATTENDANCECONTROL, changeAttendanceControl);
}
